// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_aJvbm","logo_2":"index_logo_2_btvGZ","ad_1":"index_ad_1_9-dar","ad_2":"index_ad_2_9HSyS"};